import { ButtonV2, LabraToolTipV2, useAuth } from '@labrav/react-components'
import { FooterV2 } from '../../../../common/components/FooterV2/FooterV2'
import { useStyles } from '../AddEditChannelOffer.styles'
import { ChannelPartnerPrivateOfferInCreation } from '../../../../modules/channelPartnerPrivateOffer/reducer'
import { FormikProps, useFormikContext } from 'formik'
import { useSelector } from '../../../../store'
import { useMemo } from 'react'
import { providerToAuthCloud } from '@labrav/common'
import {
  LoadingTypes,
  isLoading as Loading,
  useCurrentCloudProvider,
} from '@labrav/common'
import type { AddEditChannelOfferFooterProps } from '../types'

export const AddEditChannelOfferFooter = ({
  footerWidth,
  handleSubmitChannelOffer,
  saveChannelOffer,
}: AddEditChannelOfferFooterProps) => {
  const { classes } = useStyles()

  const isLoadingSubmit = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.SUBMIT_CHANNEL_PARTNER_PRIVATE_OFFER)
  )

  const isLoadingDraft = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.DRAFT_CHANNEL_PARTNER_PRIVATE_OFFER)
  )

  const formikProps =
    useFormikContext() as FormikProps<ChannelPartnerPrivateOfferInCreation>
  const { values } = formikProps

  const handleSaveAsDraft = async () => {
    saveChannelOffer({
      channelOffer: values,
      saveAsDraft: true,
    })
  }

  const { loading: authLoading, canDo } = useAuth()
  const selectedCloud = useCurrentCloudProvider()
  const canWriteMarketplace = useMemo(
    () =>
      !authLoading &&
      canDo({
        cloud: providerToAuthCloud(selectedCloud.toLowerCase()),
        service: 'marketplace',
        action: 'create',
      }),
    [authLoading, canDo, selectedCloud]
  )
  const permissionMessageString =
    'This action is disabled because you have read-only access'

  return (
    <FooterV2
      actions={
        <div
          className={classes.footerWrapper}
          data-testid={'channel-offer-footer-wrapper'}
        >
          <LabraToolTipV2
            tooltipPlacement="bottom"
            description={
              !canWriteMarketplace ? permissionMessageString : undefined
            }
          >
            <span>
              <ButtonV2
                styleType="outlined"
                onClick={handleSaveAsDraft}
                data-testid={'save-as-draft'}
                loading={isLoadingDraft}
                disabled={!canWriteMarketplace}
              >
                Save as draft
              </ButtonV2>
            </span>
          </LabraToolTipV2>
          <LabraToolTipV2
            tooltipPlacement="bottom"
            description={
              !canWriteMarketplace ? permissionMessageString : undefined
            }
          >
            <span>
              <ButtonV2
                data-testid="send-button-channel-offer"
                styleType="primary"
                onClick={handleSubmitChannelOffer}
                loading={isLoadingSubmit}
                disabled={!canWriteMarketplace}
              >
                Send to buyer
              </ButtonV2>
            </span>
          </LabraToolTipV2>
        </div>
      }
      width={footerWidth}
      customClass={classes.customFooter}
    />
  )
}
